import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Text,
  UseDisclosureReturn,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { deleteMatchingGroups } from "../../../../store/actions/groupList";
import { ConfirmActionModal } from "../../../modals/ConfirmActionModal";

export function DeleteAllTransactionsModal({
  selectedCount,
  disclosure,
  clearSelected,
}: {
  selectedCount: number | undefined;
  disclosure: UseDisclosureReturn;
  clearSelected: () => void;
}): React.ReactElement {
  const isSingleTransaction = selectedCount === 1;

  const showAcrossPagesWarning = (selectedCount ?? 0) > 20;

  const deleteAllTransactions = async () => {
    await deleteMatchingGroups();
    clearSelected();
  };

  return (
    <ConfirmActionModal
      disclosure={disclosure}
      title={
        isSingleTransaction ?
          "Delete selected transaction?"
        : "Delete all selected transactions?"
      }
      confirmButtonText="Delete"
      colorScheme="red"
      onConfirm={deleteAllTransactions}
    >
      <VStack alignItems="flex-start" spacing={4}>
        {isSingleTransaction ?
          <Text>
            This will delete the single transaction matching your current
            filters.
          </Text>
        : <Text>
            This will delete all{" "}
            <Text as="span" fontWeight="bold">
              {selectedCount?.toLocaleString()}
            </Text>{" "}
            transactions matching your current filters.
          </Text>
        }

        {showAcrossPagesWarning ?
          <Alert status="warning" borderRadius="md" alignItems="flex-start">
            <AlertIcon />
            <VStack alignItems="flex-start" spacing={2}>
              <AlertTitle>
                This includes transactions across all pages.
              </AlertTitle>
              <AlertDescription>
                After deleting, these transactions will need to be imported
                again or added manually if you need them later.
              </AlertDescription>
            </VStack>
          </Alert>
        : <Text color="gray.600">
            After deleting,{" "}
            {isSingleTransaction ? "this transaction" : "these transactions"}{" "}
            will need to be imported again or added manually if you need{" "}
            {isSingleTransaction ? "it" : "them"} later.
          </Text>
        }
      </VStack>
    </ConfirmActionModal>
  );
}
